import { Observable } from 'rxjs';
import { CallStatus, Ticket } from '../models';

export abstract class VoiceService {
    abstract init(): void;

    abstract destroy(): void;

    abstract deviceStatus(): Observable<CallStatus>;

    abstract connectionError(): Observable<{ ticket: Ticket }>;

    abstract registerTicket(ticketId: string, conferenceId: string): void;

    abstract clearTicket(ticketId: string): void;

    abstract pickUpCall(ticket: Ticket): void;

    abstract hasConnection(ticketId: string): boolean;

    abstract hasCall(ticketId: string): boolean;

    abstract hasCalls(): boolean;

    abstract isMuted(ticketId: string): boolean;

    abstract isOnHold(ticketId: string): boolean;

    abstract disconnect(ticketId: string, disconnectCallback?: () => void): void;

    abstract mute(ticketId: string): void;

    abstract pause(ticketId: string): void;

    abstract transfer(ticketId: string, forwardTo: string): Promise<void>;

    abstract createCall(originNumber: string, destinationNumber: string, ticketId: string): Promise<any>;
}
